// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"4fffce1ecfea467ce4da","678":"5a26b17956fd60a496ca","883":"e1ca17af6fec52fd1cd4"}[chunkId] + ".js";
};